































































import mixins from 'vue-typed-mixins'
import IntegrationSlider from '@/components/Integration/IntegrationSlider.vue'
import integrationData from '@/views/Integration/integration.json' //temporary file
import iconCheck from '@/assets/svg/rounded/check.svg?inline'
import iconChevronLeft from '@/assets/svg/rounded/chevron-left.svg?inline'
import iconClose from '@/assets/svg/rounded/close.svg?inline'
import WindowResizeListener from '@/abstract/WindowResizeListener'
import {
  ScriptRowDesktop,
  ScriptRowTablet,
  ScriptRowMobile,
} from '@/components/Scripts/ScriptRow/ScriptRow'
import { IntegrationItemData } from '@/models/integration'

interface Data {
  data: IntegrationItemData[]
  selectedItemId: string | ''
}

interface Methods {
  setItemId: (id: string) => void
  unSetItemId: () => void
  isSelected: (item: IntegrationItemData) => void
}

interface Computed {
  selectedItemData: IntegrationItemData
  currentBreakPoint: string
}

export default mixins(WindowResizeListener).extend<Data, Methods, Computed, {}>(
  {
    components: {
      IntegrationSlider,
      iconCheck,
      iconChevronLeft,
      iconClose,
      ScriptRowDesktop,
      ScriptRowTablet,
      ScriptRowMobile,
    },
    data() {
      return {
        data: integrationData,
        selectedItemId: '',
        activeImgIndex: 0,
        sliderOptions: {
          pagination: false,
          thresholdTime: 300,
          speed: 300,
          loop: false,
          slidesToScroll: 1,
          currentPage: 1,
          infinite: 3,
          centeredSlides: true,
        },
      }
    },
    methods: {
      setItemId(id) {
        this.selectedItemId = id
      },
      unSetItemId() {
        this.selectedItemId = ''
      },
      isSelected(item) {
        return item.id === this.selectedItemId
      },
    },
    computed: {
      selectedItemData() {
        if (this.selectedItemId.length) {
          return integrationData.filter(elem => {
            return elem.id === this.selectedItemId
          })[0]
        }
        return integrationData[0]
      },
      currentBreakPoint() {
        if (this.isDesktop) {
          return 'is-desktop'
        }
        if (this.isTablet) {
          return 'is-tablet'
        }
        return 'is-mobile'
      },
    },
  },
)
